import React from "react";
import { BannerDataType } from "../Restricted.index";
import {
  ButtonDefault,
  Column,
  ColumnHolder,
  MainTitle,
  SubText,
  SubTitle,
} from "../Restricted.styled";

const restrictedStrings = {
  mainTitle: "Você se interessou por essa matéria?",
  subTitle1: "Acessar conta",
  subTitle2: "Criar conta gratuita",
  subText1:
    "É só colocar login e senha e acessar <strong>o melhor jornalismo de Goiás</strong>.",
  subText2:
    "É só registrar seu e-mail para ter acesso a <strong>5 matérias por mês</strong>, sem pagar nada por isso.",
  button1: "Entrar",
  button2: "Cadastrar",
};

type RestrictedType = {
  bannerData: BannerDataType | undefined;
  handleButton1Click: any;
  handleButton2Click: any;
  trialSize: number;
};

const RestrictedGuestPaywall: React.FC<RestrictedType> = ({
  bannerData,
  handleButton1Click,
  handleButton2Click,
}) => {
  return (
    <>
      <MainTitle>
        {bannerData?.chamadaPrincipal || restrictedStrings.mainTitle}
      </MainTitle>
      <ColumnHolder>
        <Column>
          <SubTitle>{restrictedStrings.subTitle1}</SubTitle>
          <SubText>
            {bannerData?.textoLogin || restrictedStrings.subText1}
          </SubText>
          <ButtonDefault onClick={handleButton1Click}>
            {restrictedStrings.button1}
          </ButtonDefault>
        </Column>
        {bannerData && bannerData.chavesAcesso > 0 &&
        <Column>
          <SubTitle>{restrictedStrings.subTitle2}</SubTitle>
          <SubText>
            {bannerData.textoCadastro?.replace(
              "{{QUANTIDADE_DE_CHAVES}}",
              `${bannerData?.chavesAcesso}`
            ) || restrictedStrings.subText2}
          </SubText>
          <ButtonDefault onClick={handleButton2Click}>
            {restrictedStrings.button2}
          </ButtonDefault>
        </Column>
}
      </ColumnHolder>
    </>
  );
};

export default RestrictedGuestPaywall;
